const LEGACY_CACHE_PREFIX = "clayo_analytics_dashboard_v";
const PREFS_KEY = "clayo_analytics_dashboard_prefs_v1";

/** Remove any legacy dashboard payload caches from localStorage. */
export const purgeLegacyDashboardCache = () => {
  try {
    for (let i = localStorage.length - 1; i >= 0; i -= 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(LEGACY_CACHE_PREFIX)) {
        localStorage.removeItem(key);
      }
    }
  } catch {
    /* ignore */
  }
};

export const readDashboardPrefs = () => {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const writeDashboardPrefs = (prefs = {}) => {
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch {
    /* ignore quota */
  }
};
